import { useState, useEffect, useRef } from "react";
import "../styles/magic.css";
import speaker1 from "../assets/images/mangilal.png";
import speaker2 from "../assets/images/Dongyu.png";
import speaker3 from "../assets/images/himanshu.jpg";
import speaker4 from "../assets/images/geeta_1.jpg";
import empty from "../assets/images/emty.jpg";


const gallery = [
  "/gallery/conf1.jpg",
  "/gallery/conf2.jpg",
  "/gallery/conf3.jpg",
  "/gallery/conf4.jpg"
];

const kdImages = [
  "https://prakati.in/wp-content/uploads/2023/04/millets2.png",
  "https://www.thepahadistory.com/cdn/shop/articles/Millets_6533f257-2eeb-4a9e-84bf-db385029d7d2.jpg?v=1762774757&width=2048",
  "https://media.istockphoto.com/id/2158431969/photo/lovely-view-of-millet-stalks-millet-or-sorghum-plant-views-in-a-farmland-cultivation-pearls.jpg?s=612x612&w=0&k=20&c=Xc9oVNooBD4dMgnupCV_h8W_ArOswSSEs6ug2sfXJwI="
];

const keyDates = [
  { label: "Registration Opening Soon", date: "" },
  // { label: "Last date for abstract submission", date: "30-July-2026" },
  { label: "Conference Begins", date: "2026" }
];

const actionButtons = [
  { label: "Registration Now Open", style: "kd-btn-green-dark" },
  { label: "Submit an Abstract", style: "kd-btn-green-dark" },
  { label: "Program", style: "kd-btn-orange" },
  { label: "Speakers", style: "kd-btn-orange" },
  { label: "Join the mailing list", style: "kd-btn-orange" }
];

const speakers = [
  { 
    name: "Speaker 1", 
    role: "Designation 1", 
    // affiliation: "Role", 
    topic: "Designation 1",
    image: empty
  },
  { 
    name: "Speaker 2", 
    role: "Designation 2", 
    // affiliation: "Role", 
    topic: "Climate resilient crops and weather-smart agriculture models",
    image: empty
  },
  { 
    name: "Speaker 3", 
    role: "Designation 3", 
    // affiliation: "Role", 
    topic: "Organic practices, soil health, and regenerative ecosystems",
    image: empty
  },
  { 
    name: "Speaker 4", 
    role: "Designation 4", 
    // affiliation: "Role", 
    topic: "Global nutrition systems and future food supply chains",
    image: empty
  }
];

const schedule = [
  {
    day: "Day 1  – Inaugural Ceremony & GCoE Dedication",
    sessions: [
      { time: "T-45 min",      title: "Pre-Event",                         speaker: "Delegates seated; low-volume international instrumental cultural music; screening of MAGIC 2026 theme visuals on LED screens" },
      { time: "00:00 – 00:03", title: "Arrival of Chief Guest",             speaker: "Arrival of Chief Guest; received by Union Minister (Agriculture & Farmers Welfare), Secretary (DA&FW), DG ICAR, Director ICAR-IIMR; escort to Exhibition Foyer" },
      { time: "00:03 – 00:10", title: "Ribbon Cutting & Exhibition Walkthrough", speaker: "Ribbon cutting followed by Exhibition Walkthrough – Climate-Resilient Millets; Women-Led Millet Enterprises; Start-ups & FPO Innovations; International Pavilion (≈1 minute per stall with pre-briefed talking points)" },
      { time: "00:10 – 00:15", title: "Facility Visit",                    speaker: "Chief Guest visit to Advanced Phenomics Facility" },
      { time: "00:15 – 00:20", title: "Arrival at GCoE Building",          speaker: "Arrival at GCoE building; brief orientation by Director, ICAR-IIMR" },
      { time: "00:20 – 00:23", title: "Inauguration of GCoE Building",     speaker: "Inauguration of GCoE Building (Ribbon cutting) – unveiling of plaque" },
      { time: "00:23 – 00:33", title: "Facility Visit",                    speaker: "Chief Guest visits Gene Bank, Research Labs, HPC Facility" },
      { time: "00:33 – 00:35", title: "Transition",                        speaker: "Transition and escort to Main Auditorium" },
      { time: "00:35 – 00:40", title: "Ceremony",                          speaker: "Arrival at Main Auditorium; audience rises; Vande Mataram; Lamp lighting" },
      { time: "00:40 – 00:45", title: "Welcome Address",                   speaker: "Welcome Address by Secretary, DARE – context of MAGIC 2026, international participation, expected outcomes" },
      { time: "00:45 – 00:47", title: "Film Screening",                    speaker: "Screening of GCoE Film" },
      { time: "00:47 – 00:50", title: "Dedication of GCoE to the Nation",  speaker: "Dedication of GCoE Building to the Nation (digital dedication)" },
      { time: "00:50 – 01:00", title: "Ministerial Address",               speaker: "Address by Union Minister (Agriculture & Farmers Welfare) – policy commitment, global partnerships, One Health & sustainable agri-food systems" },
      { time: "01:00 – 01:02", title: "Film Screening",                    speaker: "Screening of MAHARISHI Film" },
      { time: "01:02 – 01:04", title: "Launch of MAGIC 2026",              speaker: "Launch of MAGIC 2026 (digital launch)" },
      { time: "01:04 – 01:34", title: "Exchange of MoUs",                  speaker: "Exchange of 10–12 MoUs under MAHARISHI" },
      { time: "01:34 – 01:36", title: "Global Declaration",                speaker: "Release of Global Declaration – symbolic digital endorsement" },
      { time: "01:36 – 01:56", title: "Keynote Address",                   speaker: "Address by Chief Minister – climate stress, nutritional insecurity, fragile agri-food systems; global action through MAHARISHI; leadership of the Global South in science, research & innovation" },
      { time: "01:56 – 01:59", title: "Vote of Thanks",                    speaker: "Vote of Thanks by Secretary, DA&FW" },
      { time: "01:59 – 02:02", title: "Ceremony",                          speaker: "National Anthem" },
      { time: "02:02 – 02:05", title: "Photo Opportunity",                 speaker: "Group Photograph" },
      
    ]
  },
  {
    day: "Day 2  – Technical Programme",
    sessions: [
      { time: "09:30 – 11:00", title: "Session I",   speaker: "Millets & Ancient Grains Improvement – Keynote & Technical Talks" },
      { time: "11:00 – 11:30", title: "High Tea",    speaker: "" },
      { time: "11:30 – 13:00", title: "Session II",  speaker: "Climate-Smart Millets & Ancient Grains" },
      { time: "13:00 – 14:00", title: "Lunch",       speaker: "" },
      { time: "14:30 – 16:00", title: "Session III", speaker: "Value Addition for Human Health & Nutritional Security" },
      { time: "16:00 – 16:30", title: "High Tea",    speaker: "" },
    ]
  },
  {
    day: "Day 3 – Policy, Business & MAHARISHI Stock-taking",
    sessions: [
      { time: "09:30 – 11:00", title: "Session IV",  speaker: "Business & Trade Potential – Industry & Start-ups" },
      { time: "11:00 – 11:30", title: "High Tea",    speaker: "" },
      { time: "11:30 – 13:00", title: "Session V",   speaker: "Policy Advocacy, Capacity Building, Women & Youth" },
      { time: "13:00 – 14:00", title: "Lunch",       speaker: "" },
      { time: "14:30 – 15:30", title: "Session VI",  speaker: "Stock-Taking Report of MAHARISHI" },
      { time: "15:30 – 16:00", title: "High Tea",    speaker: "" },
      { time: "16:00 – 16:30", title: "Session VII", speaker: "Panel Discussion – Mainstreaming MAG for Nutrition Security & Sustainable Food Systems" },
    ]
  }
];

const Magic = () => {
  const [current, setCurrent] = useState(0);
  const [kdSlide, setKdSlide] = useState(0);
  const [activeDay, setActiveDay] = useState(0);
  const [statsAnimated, setStatsAnimated] = useState(false);
  const [counts, setCounts] = useState({
    delegates: 0,
    countries: 0,
    speakers: 0,
    institutions: 0
  });

  // Mailing list form state
  const [mailForm, setMailForm] = useState({ email: "", message: "" });
  const [mailStatus, setMailStatus] = useState(""); // "sending" | "success" | "error" | ""

  const statsRef = useRef(null);
  const mailingListRef = useRef(null); // <-- ref for mailing list section
  const scheduleRef = useRef(null);
  const speakersRef = useRef(null);

  // Auto-transition for Key Dates slideshow
  useEffect(() => {
    const timer = setInterval(() => {
      setKdSlide(prev => (prev + 1) % kdImages.length);
    }, 3000);
    return () => clearInterval(timer);
  }, []);

  const animateCounter = (target, key, duration = 2000) => {
    const increment = target / (duration / 16);
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= target) {
        setCounts(prev => ({ ...prev, [key]: target }));
        clearInterval(timer);
      } else {
        setCounts(prev => ({ ...prev, [key]: Math.ceil(current) }));
      }
    }, 16);
  };

  useEffect(() => {
    const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          if (entry.target.classList.contains('conference-stats') && !statsAnimated) {
            setStatsAnimated(true);
            setTimeout(() => {
              animateCounter(10, 'delegates', 2000);
              animateCounter(5, 'countries', 1800);
              animateCounter(15, 'speakers', 2200);
              animateCounter(10, 'institutions', 1900);
            }, 200);
          }
        }
      });
    }, observerOptions);
    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, [statsAnimated]);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % gallery.length);
  const prevSlide = () => setCurrent((prev) => (prev - 1 + gallery.length) % gallery.length);

  // Scroll to mailing list section
  const scrollToMailingList = () => {
    if (mailingListRef.current) {
      mailingListRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  const scrollToSchedule = () => {
  if (scheduleRef.current) {
    scheduleRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
};

const scrollToSpeakers = () => {
  if (speakersRef.current) {
    speakersRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  }
};

  // Handle form submission via mailto (no redirect, uses fetch/formsubmit or similar)
  const handleMailSubmit = async (e) => {
    e.preventDefault();
    if (!mailForm.email || !mailForm.message) return;

    setMailStatus("sending");

    // Using formsubmit.co as a no-redirect email service
    try {
      const response = await fetch("https://formsubmit.co/ajax/rakeshsamala0505@gmail.com", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          email: mailForm.email,
          message: mailForm.message,
          _subject: "MAGIC Conference - Mailing List Sign Up",
          _cc: "magic2026@millets.res.in"

        })
      });

      if (response.ok) {
        setMailStatus("success");
        setMailForm({ email: "", message: "" });
        setTimeout(() => setMailStatus(""), 5000);
      } else {
        setMailStatus("error");
        setTimeout(() => setMailStatus(""), 5000);
      }
    } catch {
      setMailStatus("error");
      setTimeout(() => setMailStatus(""), 5000);
    }
  };

  return (
    <div className="conference-page">

      {/* HERO */}
      <section className="conference-hero">

        {/* TOP BAR 1 */}
        <div className="important-dates-bar">
          <strong>IMPORTANT DATES :</strong>
          {/* <span> A 3 Days Conference between 20-30 August 2026 </span> */}
          <span>MAGIC (Millets and Ancient Grains International Conference) under MAHARISHI has been postponed. Revised dates will be announced soon</span>
        </div>

        {/* NEW TOP BAR 2 – SCROLLING NOTIFICATIONS */}
        <div className="important-notification-bar">
          <div className="notification-marquee">
            <span className="alert-text">
              🌍 Join MAGIC 2026 | The 1st Millets & Ancient Grains International Conference | 2026  | Hyderabad, India | Global Experts · Innovation Expo · Food Court
            </span>
          </div>
        </div>

        <div className="hero-overlay">
          <div className="hero-badge">
            1st International Conference ·  2026
          </div>

          <h1>MAGIC</h1>

          <h2 className="magic-fullform">
            Millets and Ancient Grains International Conference
          </h2>

          <p className="hero-tagline">
            Innovation • Research • Global Collaboration
          </p>

          <div className="hero-info-cards">
            <a
              href="https://calendar.google.com/calendar/render?action=TEMPLATE&text=MAGIC+2026+Conference&dates=20260701T090000Z/20261130T170000Z&details=Millets+and+Ancient+Grains+International+Conference&location=Indian+Institute+of+Millets+Research+Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-info-card"
            >
              <span className="hero-info-icon">📅</span>
              <span className="hero-info-text">
                <span className="hero-info-main"> 2026</span>
                {/* <span className="hero-info-sub">Subject to confirmation of dates from PMO</span> */}
              </span>
            </a>

            <a
              href="https://www.google.com/maps/search/?api=1&query=Indian+Institute+of+Millets+Research+Hyderabad"
              target="_blank"
              rel="noopener noreferrer"
              className="hero-info-card"
            >
              <span className="hero-info-icon">📍</span>
              <span className="hero-info-text">
                <span className="hero-info-main">Global Center of Excellence on Millets</span>
                <span className="hero-info-sub">ICAR-Indian Institute of Millets Research, Hyderabad</span>
              </span>
            </a>
          </div>

          <button
            className="hero-cta"
            onClick={() => window.location.href = '/magic2026_registration'}
          >
            Register Now
          </button>
        </div>
      </section>

       {/* STATS */}
      <section className="conference-stats animate-on-scroll" ref={statsRef}>
        <div className="stat-card">
          <h3>{counts.delegates}+</h3>
          <span>Startups</span>
        </div>
        <div className="stat-card">
          <h3>{counts.countries}+</h3>
          <span>Industries</span>
        </div>
        <div className="stat-card">
          <h3>{counts.speakers}+</h3>
          <span>Incubation cells</span>
        </div>
        <div className="stat-card">
          <h3>{counts.institutions}+</h3>
          <span>Banks</span>
        </div>
      </section>

      

      {/* KEY DATES SECTION */}
      <div className="kd-outer-bg">
        <section className="kd-section animate-on-scroll">

          {/* LEFT COLUMN */}
          <div className="kd-left">

            {/* Row 1: Tall Slideshow */}
            <div className="kd-slideshow-wrapper">
              {kdImages.map((img, idx) => (
                <img
                  key={idx}
                  src={img}
                  alt={`Conference highlight ${idx + 1}`}
                  className={`kd-slide-img ${kdSlide === idx ? "kd-slide-active" : ""}`}
                />
              ))}
              <div className="kd-slide-dots">
                {kdImages.map((_, idx) => (
                  <span
                    key={idx}
                    className={kdSlide === idx ? "kd-dot-active" : ""}
                    onClick={() => setKdSlide(idx)}
                  />
                ))}
              </div>
              <div className="kd-slide-overlay-text">
                <span>MAGIC Conference 2026</span>
              </div>
            </div>

            {/* Row 2: Description */}
            <div className="kd-description">
              <h3>Global Voices, Shared Vision for Sustainable Agriculture through millets and ancient grains</h3>
              <p>
                The MAGIC Conference unites researchers, innovators, 
                and policy makers from across the globe to address the 
                most pressing challenges in sustainable agriculture, including 
                climate-resilient crop science. This premier event sets the agenda 
                for the future of food systems worldwide. Join us and be part of the 
                conversation that matters most.
.
              </p>
            </div>

            {/* Row 3: Two Places */}
            <div className="kd-places">
              <div className="kd-place-card">
                <h4>Venue</h4>
                <p className="kd-place-name">Global Centre of Excellence on Millets</p>
                <p className="kd-place-detail">ICAR-Indian Institute of Millets Research, Hyderabad, India</p>
              </div>
              <div className="kd-place-divider" />
              {/* <div className="kd-place-card">
                <h4>Virtual Option</h4>
                <p className="kd-place-name">Online Live Streaming Platform</p>
                <p className="kd-place-detail">Accessible Worldwide</p>
              </div> */}
            </div>

          </div>

          {/* RIGHT COLUMN */}
          <div className="kd-right">

            {/* Key Dates Box */}
            <div className="kd-dates-box">
              <div className="kd-dates-header">
                <h2 className="kd-right-title">Key Dates</h2>
              </div>
              <div className="kd-dates-list">
                {keyDates.map((item, idx) => (
                  <div key={idx} className="kd-date-item">
                    <p className="kd-date-label">{item.label}</p>
                    <p className="kd-date-value">{item.date}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Action Buttons */}
            <div className="kd-action-buttons">
  {actionButtons.map((btn, idx) => {

    if (btn.label === "Join the mailing list") {
      return (
        <button
          key={idx}
          className={`kd-action-btn ${btn.style}`}
          onClick={scrollToMailingList}
        >
          {btn.label}
        </button>
      );
    }

    if (btn.label === "Program") {
      return (
        <button
          key={idx}
          className={`kd-action-btn ${btn.style}`}
          onClick={scrollToSchedule}
        >
          {btn.label}
        </button>
      );
    }

    if (btn.label === "Speakers") {
      return (
        <button
          key={idx}
          className={`kd-action-btn ${btn.style}`}
          onClick={scrollToSpeakers}
        >
          {btn.label}
        </button>
      );
    }

    if (btn.label === "Registration Now Open") {
      return (
        <button
          key={idx}
          className={`kd-action-btn ${btn.style}`}
          onClick={() => window.location.href = "/magic2026_registration"}
        >
          {btn.label}
        </button>
      );
    }

    if (btn.label === "Submit an Abstract") {
      return (
        <button
          key={idx}
          className={`kd-action-btn ${btn.style}`}
          onClick={() => window.location.href = "/magic2026_registration"}
        >
          {btn.label}
        </button>
      );
    }

    return (
      <button
        key={idx}
        className={`kd-action-btn ${btn.style}`}
      >
        {btn.label}
      </button>
    );
  })}
</div>

          </div>
        </section>
      </div>

      {/* OVERVIEW */}
<section className="conference-overview animate-on-scroll">
  <div className="overview-container">

    <h2>About The Conference</h2>

    <p className="overview-text">
      The First Millets & Ancient Grains International Conference (MAGIC) aims to address the
      critical challenges faced by stakeholders involved in millet and ancient grains research
      and cultivation, including low yields, lack of adequate processing infrastructure, weak
      value chains, and the social stigma of "lesser grains." This pivotal event will provide
      a global platform to showcase the numerous benefits of millets & ancient grains while
      tackling these obstacles.
    </p>

    <ul className="overview-list">
  <li>➤ The conference will bring together policymakers, researchers, think tanks, funding organizations, start-ups, and agricultural leaders to promote collaboration.</li>

  <li>➤ It will highlight the role of millets and ancient grains in sustainable agriculture, food security, nutrition, and climate change mitigation.</li>

  <li>➤ Global dialogue will help develop strategies to advance research and strengthen policy support for millet markets.</li>

  <li>➤ Investment and partnerships will create new opportunities for the global millet ecosystem.</li>

  <li>➤ Public awareness will be raised about the nutritional and environmental benefits of millets and ancient grains.</li>
</ul>

  </div>
</section>

      {/* CONFERENCE TRACKS */}
      <section className="conference-tracks animate-on-scroll">
  <h2 className="section-title">Conference Themes</h2>
  <div className="tracks-grid">
    
    <div className="track-card">
      <div className="track-icon">🌱</div>
      <h3>Advancing Genomics, Grain Diversity, Evolution & Genetic Resources
</h3>
      {/* <p>Advancing Genomics, Grain Diversity, Evolution & Genetic Resources
</p> */}
    </div>

    <div className="track-card">
  <div className="track-icon">🌦️</div>
  <h3>Climate-Smart Millets & Ancient Grains</h3>
  {/* <p>Climate-smart Millets & Ancient Grains</p> */}
</div>

    <div className="track-card">
      <div className="track-icon">🌾</div>
      <h3>Value Addition in Millets for Human Health</h3>
      {/* <p>Value Addition in Millets for One Health</p> */}
    </div>

    <div className="track-card">
      <div className="track-icon">🌍</div>
      <h3>Trade Potential of Millets – Industry & Start-up Entrepreneurs</h3>
      {/* <p>Trade Potential of Millets - Industry Perspective</p> */}
    </div>

    <div className="track-card">
      <div className="track-icon">📜</div>
      <h3>Collaboration, Social & Economic Impacts of MAG Research</h3>
      {/* <p>Policy frameworks, government initiatives, and strategies for promoting millets and sustainable agriculture.</p> */}
    </div>

  </div>
</section>

      {/* KEYNOTE SPEAKERS */}
      <section
        ref={speakersRef}
        className="conference-speakers animate-on-scroll"
      >
        <h2 className="section-title">Keynote Speakers</h2>
        <div className="speakers-grid">
          {speakers.map((speaker, idx) => (
            <div key={idx} className="speaker-card flip-card">
              <div className="flip-inner">
                <div className="flip-front">
                  <img src={speaker.image} alt={speaker.name} />
                  <h3>{speaker.name}</h3>
                  <p className="speaker-role">{speaker.role}</p>
                  <p className="speaker-affiliation">{speaker.affiliation}</p>
                </div>
                <div className="flip-back">
                  <p>{speaker.topic}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

     

      {/* SCHEDULE/AGENDA */}
      <section
        className="conference-schedule animate-on-scroll"
        ref={scheduleRef}
      >
        <h2 className="section-title">Event Schedule</h2>
        <div className="schedule-tabs">
          {schedule.map((day, idx) => (
            <button
              key={idx}
              className={activeDay === idx ? "tab-active" : ""}
              onClick={() => setActiveDay(idx)}
            >
              {day.day}
            </button>
          ))}
        </div>
        <div className="schedule-content">
          {schedule[activeDay].sessions.map((session, idx) => (
            <div key={idx} className="schedule-item">
              <div className="schedule-time">{session.time}</div>
              <div className="schedule-details">
                <h4>{session.title}</h4>
                {session.speaker && <p>{session.speaker}</p>}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* GALLERY */}
      {/* <section className="conference-gallery animate-on-scroll">
        <h2 className="section-title">Event Highlights</h2>
        <div className="gallery-slider">
          <button className="gallery-nav" onClick={prevSlide}>‹</button>
          <img src={gallery[current]} alt="conference highlight" />
          <button className="gallery-nav" onClick={nextSlide}>›</button>
        </div>
        <div className="gallery-dots">
          {gallery.map((_, idx) => (
            <span
              key={idx}
              className={current === idx ? "dot-active" : ""}
              onClick={() => setCurrent(idx)}
            />
          ))}
        </div>
      </section> */}

      {/* TESTIMONIALS */}
      {/* <section className="conference-testimonials animate-on-scroll">
        <h2 className="section-title">What Attendees Say</h2>
        <div className="testimonials-grid">
          <div className="testimonial-card">
            <p>"An incredible gathering of brilliant minds. The networking opportunities alone were worth the trip from Brazil!"</p>
            <div className="testimonial-author">
              <strong>Dr. Ana Silva</strong>
              <span>University of São Paulo</span>
            </div>
          </div>
          <div className="testimonial-card">
            <p>"The research presentations were world-class. I left with new collaborations and fresh perspectives on climate resilience."</p>
            <div className="testimonial-author">
              <strong>Prof. Michael O'Brien</strong>
              <span>Cornell University</span>
            </div>
          </div>
          <div className="testimonial-card">
            <p>"Excellent organization and cutting-edge content. This conference sets the standard for agricultural research events."</p>
            <div className="testimonial-author">
              <strong>Dr. Fatima Al-Rashid</strong>
              <span>King Saud University</span>
            </div>
          </div>
        </div>
      </section> */}

      {/* REGISTRATION CTA */}
      <section className="conference-registration animate-on-scroll">
        <div className="registration-content">
          <h2>Join Us in 2026</h2>
          <p>Be part of the  upcoming International Agriculture Conference. Registration Opens soon!</p>
          <div className="registration-buttons">
            <button
                  className="hero-cta"
                  onClick={() => window.location.href = '/magic2026_registration'}
                >
                  Register Now
                </button>

            <button className="btn-secondary" onClick={() => window.location.href = '/magic2026_registration'}>
              Submit Abstract
            </button>
          </div>
        </div>
      </section>

      {/* CLOSING */}
      <section className="conference-summary animate-on-scroll">
        <h2 className="section-title">Conference Outcomes</h2>
        <p>
          The conference will strengthen global research collaboration in the millet sector by promoting joint projects, knowledge sharing, and increased funding opportunities. It will drive advancements in breeding and biotechnology to develop high-yield, climate-resilient, and pest-resistant millet varieties. By promoting millet production and inclusion in public food programs, the conference will enhance food and nutritional security. Engagement with start-ups and agri-tech enterprises will foster innovation and strengthen market linkages across the millet value chain. It will encourage sustainable and climate-smart agricultural practices to improve soil health and resilience to climate change. Policy recommendations emerging from the conference will integrate millet research into national and global food policies aligned with the 2030 Sustainable Development Goals. A digital knowledge platform will be established to share research updates, best practices, and case studies globally. Overall, the conference will enhance capacity building, promote innovation, strengthen global partnerships, and support long-term investments to accelerate millet adoption worldwide.
        </p>
        {/* <button className="download-btn">Download Conference Brochures</button> */}
      </section>

      {/* PARTNERS */}
      <section className="conference-partners">
        <h2 className="section-title">Our Partners</h2>
        <div className="partner-logos-wrapper">
          <div className="partner-logos">
            {/* original set */}
            <div className="partner-logo-tile"><img src="/icons/ICAR_LOGO.PNG" alt="ICAR logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/MAFW.png" alt="ICRISAT logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/icrisat.png" alt="ICMR-NIN logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="ICAR-NBPGR logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="icar-neh logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="icar-vpkas logo" /></div>
            
            {/* duplicate set for seamless loop */}
            <div className="partner-logo-tile"><img src="/icons/ICAR_LOGO.PNG" alt="ICAR logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/MAFW.png" alt="ICRISAT logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/icrisat.png" alt="ICMR-NIN logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="ICAR-NBPGR logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="icar-neh logo" /></div>
            <div className="partner-logo-tile"><img src="/icons/empty_partner_logo.jpg" alt="icar-vpkas logo" /></div>
          </div>
        </div>
      </section>

      {/* ===== MAILING LIST / CONTACT SECTION ===== */}
      <section className="mailing-list-section animate-on-scroll" ref={mailingListRef} id="mailing-list">
        <div className="mailing-list-inner">

          {/* Left: decorative info panel */}
          <div className="mailing-list-info">
            <div className="mailing-list-icon">✉</div>
            <h2>Stay in touch</h2>
            <p>
              Join our mailing list to receive the latest updates on speakers,
              schedules, abstract submissions, and registration
              opportunities for the MAGIC Conference 2026.
            </p>
            <ul className="mailing-list-perks">
              <li>
                <span className="perk-dot" />
                Exclusive registration alerts
              </li>
              <li>
                <span className="perk-dot" />
                Speaker announcements & program updates
              </li>
              <li>
                <span className="perk-dot" />
                Abstract submission reminders
              </li>
              <li>
                <span className="perk-dot" />
                Conference news & highlights
              </li>
            </ul>
          </div>

          {/* Right: form */}
          <div className="mailing-list-form-wrapper">
            <div className="mailing-list-form-card">
              <h3>Get in Touch</h3>
              <p className="form-subtitle">Drop us your email and message — we'll get back to you!</p>

              <form className="mailing-list-form" onSubmit={handleMailSubmit}>
                <div className="form-field">
                  <label htmlFor="ml-email">Your Email Address</label>
                  <div className="input-wrapper">
                    <span className="input-icon">@</span>
                    <input
                      id="ml-email"
                      type="email"
                      placeholder="you@example.com"
                      value={mailForm.email}
                      onChange={e => setMailForm(prev => ({ ...prev, email: e.target.value }))}
                      required
                    />
                  </div>
                </div>

                <div className="form-field">
                  <label htmlFor="ml-message">Your Message</label>
                  <textarea
                    id="ml-message"
                    rows={5}
                    placeholder="Write your message, enquiry, or just say hello..."
                    value={mailForm.message}
                    onChange={e => setMailForm(prev => ({ ...prev, message: e.target.value }))}
                    required
                  />
                </div>

                <button
                  type="submit"
                  className={`mailing-submit-btn ${mailStatus === "sending" ? "sending" : ""}`}
                  disabled={mailStatus === "sending"}
                >
                  {mailStatus === "sending" ? (
                    <>
                      <span className="spinner" />
                      Sending...
                    </>
                  ) : (
                    <>
                      <span>Send Message</span>
                      <span className="btn-arrow">→</span>
                    </>
                  )}
                </button>

                {mailStatus === "success" && (
                  <div className="form-feedback success">
                    ✓ Message sent successfully! We'll be in touch soon.
                  </div>
                )}
                {mailStatus === "error" && (
                  <div className="form-feedback error">
                    ✗ Something went wrong. Please try again or email us directly.
                  </div>
                )}
              </form>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
};

export default Magic;